import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { getPortalUrl } from '../lib/portal';
import { CreatorNavbar } from '../components/UI/CreatorNavbar';
import { FullPageSpinner } from '../components/UI/Spinner';
import appStyles from '../App.module.css';

export const CreatorLayout: React.FC = () => {
  const { user, initialized } = useAuthStore();

  if (!initialized) return <FullPageSpinner />;
  if (!user) return <Navigate to="/login" replace />;

  if (!user.betaApproved && !user.isOwner) {
    if (import.meta.env.PROD) {
      window.location.href = getPortalUrl('viewer') + '/waitlist/pending';
      return <FullPageSpinner />;
    } else {
      console.warn('[portal] Non-approved user on creator layout — in prod would redirect to viewer waitlist');
    }
  }

  return (
    <div className={appStyles['shell']}>
      <CreatorNavbar />
      <main>
        <Outlet />
      </main>
    </div>
  );
};
